module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'From Rewards Bazaar',
        viewAll: 'View all',
        add: 'Add'
    };
    return resources[label];
};
